import { cloneDeep } from '@apollo/client/utilities';
import { EntityType } from '../comment';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { Tag } from './tag';

export class TagInput extends Tag implements EntityInput<Tag> {
  forCreate(): CreateTagInput {
    return CreateTagInput.from(this, CreateTagInput);
  }

  forUpdate(): UpdateTagInput {
    return UpdateTagInput.from(this, UpdateTagInput);
  }

  forDelete(): DeleteTagInput {
    return DeleteTagInput.from(this, DeleteTagInput);
  }

  validate(): boolean {
    if (!this.name) return false;
    if (!this.type) return false;
    if (!this.color) return false;

    return true;
  }

  hasChanges(original: Tag | undefined): boolean {
    if (!original) return true;

    if (this.name !== original.name) return true;
    if (this.type !== original.type) return true;
    if (this.color !== original.color) return true;

    return false;
  }

  withName(name: string) {
    this.name = name;
    return cloneDeep(this);
  }

  withType(type: EntityType) {
    this.type = type;
    return cloneDeep(this);
  }

  withDescription(description: string) {
    this.description = description;
    return cloneDeep(this);
  }

  withColor(color: string) {
    this.color = color;
    return cloneDeep(this);
  }
}

export class CreateTagInput extends forCreate(Tag) {}

export class UpdateTagInput extends forUpdate(Tag) {}

export class DeleteTagInput extends forDelete(Tag) {}
